import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteExternalEmbedWidgetFragment = contentfulGql`#graphql
  fragment EntWebsiteCerosWidget on EntWebsiteCerosWidget {
    slug
    embeddedCode
  }
`;

export const entWebsiteBlockExternalEmbedWidgetQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteExternalEmbedWidgetFragment}
  query entWebsiteBlockCerosWidget($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteCerosWidget
      }
    }
  }
`;
